// Nav UI v2 — static registries powering the header's "Sector" link builder
// (Settings > Manage Global Header). NOTE: when a new page/route is added to
// App.js, add one matching entry to PAGE_REGISTRY below so it becomes
// selectable in the "Add Page Link" picker.
import {
  Home, Truck, Settings as SettingsIcon, FileText, Package, ClipboardList, Phone, PhoneCall,
  ShoppingCart, Shield, Users2, Link2, ExternalLink, TrendingUp, LineChart, BarChart2, PackageCheck,
  Building2, Car, MapPin, CalendarClock, AlertTriangle, Send, FileQuestion, Star, Target,
  DollarSign, Users, Layers, FolderKanban, StickyNote, UserPlus, Upload, Warehouse, ListChecks, Globe,
} from 'lucide-react';
// More icons for the side bar and the Spaces. (Three share a name with something built into JavaScript, so they are imported under another name.)
import {
  // Numbers and counting
  Hash, Binary, Calculator, ListOrdered, Sigma, Percent, Pi, Radical, Variable, Infinity as InfinityIcon, Plus, Minus, Equal, Divide, ArrowUp01, ArrowDown01, ArrowUp10, ArrowDown10, Tally1, Tally2, Tally3, Tally4, Tally5, Dices, Dice1, Dice2, Dice3, Dice4, Dice5, Dice6, Gauge, Scale, Weight, Ruler, Timer, Hourglass, Barcode, ScanBarcode, QrCode,
  // Money
  CircleDollarSign, PoundSterling, Coins, Banknote, Receipt, Wallet, PiggyBank, CreditCard, BadgePoundSterling, BadgePercent,
  // Charts and data
  BarChart3, BarChart4, PieChart, AreaChart, Activity, TrendingDown, CandlestickChart, Sheet, Table, Table2, FileSpreadsheet, FileBarChart, Database, Server,
  // Time and planning
  Calendar, CalendarDays, CalendarCheck, Clock, Clock3, History, ListTodo, Kanban, GanttChart, Workflow,
  // Messages and people
  Bell, BellRing, Mail, MessageSquare, MessagesSquare, Megaphone, PhoneIncoming, PhoneOutgoing, UserCheck, UserCog, IdCard, Contact, CircleUser, Handshake, ThumbsUp, Heart, Briefcase,
  // Stock and transport
  Box, Boxes, Container, Forklift, Package2, PackagePlus, PackageMinus, PackageSearch, PackageOpen, Ship, Plane, Train, Bus, Bike, Fuel, Route, Navigation, Map as MapIcon, Compass, Factory, Store, Landmark, Building, Hammer, Wrench, HardHat, Construction,
  // Documents and files
  Clipboard, ClipboardCheck, FileCheck, FilePlus, FileSearch, Folder, FolderOpen, Archive, Printer, Download, Paperclip, Notebook, NotebookPen, BookOpen, Stamp, Tag, Tags, Bookmark, Flag,
  // Status and symbols
  Search, Eye, Filter, SlidersHorizontal, Cog, Lock, KeyRound, ShieldCheck, CircleCheck, CircleAlert, Info, CircleHelp, BadgeCheck, Siren, Zap, Sparkles, Lightbulb, Rocket, Trophy, Medal, Award, Crown, Gem, Flame, Sun, Moon, Leaf, Droplets, Wind, Thermometer,
  // Layout and more
  LayoutDashboard, LayoutGrid, Grid3x3, Columns3, Rows3, Layers2, Layers3, Blocks, Shapes, Component, Puzzle, Network, GitBranch, RefreshCw, RotateCw, Repeat, Shuffle, ArrowLeftRight, Share2, Wifi, Smartphone, Monitor, Laptop, Camera, Image as ImageIcon, Video, Mic, Headphones, Pin, Pencil, Scissors, Bug, GraduationCap,
} from 'lucide-react';

export const ICON_MAP = {
  Home, Truck, SettingsIcon, FileText, Package, ClipboardList, Phone, PhoneCall,
  ShoppingCart, Shield, Users2, Link2, ExternalLink, TrendingUp, LineChart, BarChart2, PackageCheck,
  Building2, Car, MapPin, CalendarClock, AlertTriangle, Send, FileQuestion, Star, Target,
  DollarSign, Users, Layers, FolderKanban, StickyNote, UserPlus, Upload, Warehouse, ListChecks, Globe,
};

// The new icons, in the order the picker lists them: numbers and counting first.
Object.assign(ICON_MAP, {
  // Numbers and counting
  Hash, Binary, Calculator, ListOrdered, Sigma, Percent, Pi, Radical, Variable, Infinity: InfinityIcon, Plus, Minus, Equal, Divide, ArrowUp01, ArrowDown01, ArrowUp10, ArrowDown10, Tally1, Tally2, Tally3, Tally4, Tally5, Dices, Dice1, Dice2, Dice3, Dice4, Dice5, Dice6, Gauge, Scale, Weight, Ruler, Timer, Hourglass, Barcode, ScanBarcode, QrCode,
  // Money
  CircleDollarSign, PoundSterling, Coins, Banknote, Receipt, Wallet, PiggyBank, CreditCard, BadgePoundSterling, BadgePercent,
  // Charts and data
  BarChart3, BarChart4, PieChart, AreaChart, Activity, TrendingDown, CandlestickChart, Sheet, Table, Table2, FileSpreadsheet, FileBarChart, Database, Server,
  // Time and planning
  Calendar, CalendarDays, CalendarCheck, Clock, Clock3, History, ListTodo, Kanban, GanttChart, Workflow,
  // Messages and people
  Bell, BellRing, Mail, MessageSquare, MessagesSquare, Megaphone, PhoneIncoming, PhoneOutgoing, UserCheck, UserCog, IdCard, Contact, CircleUser, Handshake, ThumbsUp, Heart, Briefcase,
  // Stock and transport
  Box, Boxes, Container, Forklift, Package2, PackagePlus, PackageMinus, PackageSearch, PackageOpen, Ship, Plane, Train, Bus, Bike, Fuel, Route, Navigation, Map: MapIcon, Compass, Factory, Store, Landmark, Building, Hammer, Wrench, HardHat, Construction,
  // Documents and files
  Clipboard, ClipboardCheck, FileCheck, FilePlus, FileSearch, Folder, FolderOpen, Archive, Printer, Download, Paperclip, Notebook, NotebookPen, BookOpen, Stamp, Tag, Tags, Bookmark, Flag,
  // Status and symbols
  Search, Eye, Filter, SlidersHorizontal, Cog, Lock, KeyRound, ShieldCheck, CircleCheck, CircleAlert, Info, CircleHelp, BadgeCheck, Siren, Zap, Sparkles, Lightbulb, Rocket, Trophy, Medal, Award, Crown, Gem, Flame, Sun, Moon, Leaf, Droplets, Wind, Thermometer,
  // Layout and more
  LayoutDashboard, LayoutGrid, Grid3x3, Columns3, Rows3, Layers2, Layers3, Blocks, Shapes, Component, Puzzle, Network, GitBranch, RefreshCw, RotateCw, Repeat, Shuffle, ArrowLeftRight, Share2, Wifi, Smartphone, Monitor, Laptop, Camera, Image: ImageIcon, Video, Mic, Headphones, Pin, Pencil, Scissors, Bug, GraduationCap,
});
// Words that find an icon in the picker's search as well as its name: typing "count" finds the tally marks, "number" the dice and the ordered list, and so on.
export const ICON_KEYWORDS = {
  Hash: 'number numbers count counting hash tag pound digits',
  Binary: 'number numbers binary digits zero one code',
  Calculator: 'maths calculate calculation numbers sum total add',
  ListOrdered: 'numbered list order ranking 1 2 3 sequence',
  Sigma: 'total sum add up count',
  Percent: 'percentage percent discount rebate margin',
  Pi: 'maths number circle',
  Radical: 'maths root square number',
  Variable: 'maths formula value',
  Infinity: 'unlimited endless loop',
  Plus: 'add new more count',
  Minus: 'take away less subtract',
  Equal: 'equals total same match',
  Divide: 'split share maths',
  ArrowUp01: 'sort ascending numbers 0 1 order lowest',
  ArrowDown01: 'sort descending numbers 0 1 order',
  ArrowUp10: 'sort ascending numbers 1 0 order highest',
  ArrowDown10: 'sort descending numbers 1 0 order',
  Tally1: 'count counting tally mark one 1',
  Tally2: 'count counting tally marks two 2',
  Tally3: 'count counting tally marks three 3',
  Tally4: 'count counting tally marks four 4',
  Tally5: 'count counting tally marks five 5',
  Dices: 'dice die dices numbers random',
  Dice1: 'dice die number one 1 random',
  Dice2: 'dice die number two 2 random',
  Dice3: 'dice die number three 3 random',
  Dice4: 'dice die number four 4 random',
  Dice5: 'dice die number five 5 random',
  Dice6: 'dice die number six 6 random',
  Gauge: 'meter dial speed level count measure',
  Scale: 'weight balance weigh measure',
  Weight: 'weight kilos tonnes measure',
  Ruler: 'measure length size',
  Timer: 'time stopwatch count countdown',
  Hourglass: 'time wait countdown',
  Barcode: 'scan stock code number product',
  ScanBarcode: 'scan stock code number product',
  QrCode: 'scan code link',
  CircleDollarSign: 'money pounds cash price value',
  PoundSterling: 'money pounds cash price gbp',
  Coins: 'money cash change price',
  Banknote: 'money cash notes price',
  Receipt: 'bill invoice till cost',
  Wallet: 'money funds',
  PiggyBank: 'savings money',
  CreditCard: 'payment card money',
  BadgePoundSterling: 'money pounds price',
  BadgePercent: 'discount percent rebate offer',
  BarChart3: 'chart graph bars numbers stats',
  BarChart4: 'chart graph bars numbers stats',
  PieChart: 'chart graph share numbers stats',
  AreaChart: 'chart graph numbers stats',
  Activity: 'pulse graph live stats',
  TrendingDown: 'fall down decrease stats',
  CandlestickChart: 'chart stock market numbers',
  Table: 'grid rows columns data numbers',
  Table2: 'grid rows columns data numbers',
  Sheet: 'spreadsheet grid numbers',
  FileSpreadsheet: 'spreadsheet excel numbers data',
  FileBarChart: 'report numbers stats',
  Calendar: 'date day diary',
  CalendarDays: 'date days diary month',
  CalendarCheck: 'date booked done',
  Clock: 'time hour',
  Clock3: 'time hour',
  History: 'recent past back',
  ListTodo: 'tasks to do checklist',
  Kanban: 'board columns tasks',
  GanttChart: 'plan timeline schedule',
  Workflow: 'process steps flow',
  Box: 'stock parcel',
  Boxes: 'stock parcels pallet',
  Container: 'shipping stock',
  Forklift: 'warehouse stock lift',
  PackagePlus: 'add stock',
  PackageMinus: 'remove stock',
  PackageSearch: 'find stock',
  PackageOpen: 'goods in unpack stock',
};
export const ICON_OPTIONS = Object.keys(ICON_MAP);

// Every selectable app page — mirrors the route guards in App.js.
export const PAGE_REGISTRY = [
  { route: '/', label: 'Home', icon: 'Home', permission_key: null },
  { route: '/transport', label: 'Transport', icon: 'Truck', permission_key: 'can_access_transport' },
  { route: '/settings', label: 'Settings', icon: 'SettingsIcon', permission_key: 'can_access_settings' },
  { route: '/reports-hub', label: 'Reports', icon: 'FileText', permission_key: 'can_access_reports' },
  { route: '/company-car', label: 'Company Car', icon: 'Car', permission_key: null },
  { route: '/areas', label: 'Areas', icon: 'MapPin', permission_key: null },
  { route: '/mileage-tracker', label: 'Mileage Tracker', icon: 'Car', permission_key: null },
  { route: '/staffology', label: 'Staffology', icon: 'ExternalLink', permission_key: 'can_access_staffology' },
  { route: '/group-absence-calendar', label: 'Annual Leave', icon: 'CalendarClock', permission_key: 'can_access_al_button' },
  { route: '/crm', label: 'CRM Portal', icon: 'Building2', permission_key: 'can_access_crm' },
  { route: '/sales-dashboard', label: 'Sales Dashboard', icon: 'TrendingUp', permission_key: 'can_access_sales_dashboard' },
  { route: '/projects', label: 'Projects', icon: 'ClipboardList', permission_key: null },
  { route: '/sales-tracker', label: 'Sales Tracker', icon: 'LineChart', permission_key: 'can_view_sales_tracker' },
  { route: '/error-log', label: 'Error Log', icon: 'AlertTriangle', permission_key: 'can_view_error_log' },
  { route: '/pi-counts', label: 'PI Counts', icon: 'ClipboardList', permission_key: 'can_access_pi_counts' },
  { route: '/pi-counts-warehouse', label: 'PI Counts Warehouse', icon: 'PackageCheck', permission_key: 'can_view_pi_warehouse' },
  { route: '/goods-in', label: 'Goods In', icon: 'PackageCheck', permission_key: 'can_access_goods_in' },
  { route: '/goods-in-warehouse', label: 'Goods In W/H', icon: 'Warehouse', permission_key: 'can_access_goods_in_warehouse' },
  { route: '/m45-hub', label: 'M4.5 Hub', icon: 'Package', permission_key: null },
  { route: '/stock-transfer', label: 'Stock Transfer', icon: 'Package', permission_key: 'can_access_stock_transfer' },
  { route: '/po-expenses', label: 'P.O. Expenses', icon: 'ClipboardList', permission_key: 'can_access_po_expenses' },
  { route: '/manage-calls', label: 'Manage Calls', icon: 'PhoneCall', permission_key: null },
  { route: '/sales-hub', label: 'Sales Hub', icon: 'Users2', permission_key: null },
  { route: '/project-tracking', label: 'Project Tracking', icon: 'FolderKanban', permission_key: 'can_view_project_tracking' },
  { route: '/spellers', label: 'Spellers', icon: 'Layers', permission_key: 'can_view_project_tracking' },
  { route: '/bi-reports', label: 'BI Reports', icon: 'LineChart', permission_key: 'can_access_bi_reports' },
  { route: '/price-increases', label: 'Price Increases', icon: 'TrendingUp', permission_key: 'can_access_po_expenses' },
  { route: '/stock-management', label: 'Stock Control', icon: 'Package', permission_key: 'can_access_stock_management' },
  { route: '/automations', label: 'Automations', icon: 'Send', permission_key: null },
  { route: '/sdp-crm', label: 'SDP CRM', icon: 'Building2', permission_key: null },
];

// The site's existing header dropdowns/pills — selectable as a single
// "Existing Dropdown" item (each renders the real, unmodified component).
export const BUILTIN_DROPDOWNS = [
  { builtin_key: 'proforma', label: 'Pro Forma', icon: 'FileText', permission_key: 'can_access_proforma' },
  { builtin_key: 'quotes', label: 'Quotes', icon: 'FileQuestion', permission_key: 'can_access_quotes' },
  { builtin_key: 'sales_crm', label: 'Sales / CRM', icon: 'Phone', permission_key: null },
  { builtin_key: 'stock_transfer_requests', label: 'Stock Trf/Req', icon: 'Package', permission_key: null },
  { builtin_key: 'admin', label: 'Admin', icon: 'Shield', permission_key: null },
  { builtin_key: 'stock_management', label: 'Stock Control', icon: 'Package', permission_key: 'can_access_stock_management' },
];

// ─── Single links: every item inside the header's drop-downs, available as a link of its own ───────────────────────────────────────
// (Settings > User Interface > User Spaces > Links > Add Link > Single link.) Each does exactly what the same item does inside its drop-down, with the same access checks.
//   key         what the link stores (its place on the side bar and its icon and colour are kept under it); the part before the first _ is the drop-down it comes from
//   group       the drop-down it belongs to (ACTION_GROUPS has its name)
//   permission_key  the link is hidden from a person for whom this is switched OFF (on unless switched off)
//   requires    the link is shown only to a person this is ON for (off unless given), as inside the drop-down
//   teamManager shown to team managers
// The Sales / CRM ones are done by components/LogCallDropdownPill.jsx itself (so a call that leads on to a quote, and the CRM access check, work as they do inside it).
export const ACTION_GROUPS = {
  crm: 'Sales / CRM', quotes: 'Quotes', proforma: 'Pro Forma', stock: 'Stock Trf/Req', stockctl: 'Stock Control', admin: 'Admin',
};
export const BUILTIN_ACTIONS = [
  { key: 'crm_sales_hub', group: 'crm', label: 'Sales Hub', icon: 'TrendingUp' },
  { key: 'crm_customer_management', group: 'crm', label: 'Customer Management', icon: 'StickyNote' },
  { key: 'crm_add_quote_project', group: 'crm', label: 'Add Project / Quote', icon: 'FilePlus' },
  { key: 'crm_search_barbour', group: 'crm', label: 'Search Barbour', icon: 'Building2' },
  { key: 'crm_search_barbour_v2', group: 'crm', label: 'Barbour Search V2', icon: 'Building2' },
  { key: 'crm_add_call', group: 'crm', label: 'Add Call', icon: 'PhoneCall' },
  { key: 'crm_manage_calls', group: 'crm', label: 'Manage Calls', icon: 'ListChecks' },
  { key: 'crm_schedule_call', group: 'crm', label: 'Schedule Call', icon: 'CalendarClock' },
  { key: 'crm_project_tracking', group: 'crm', label: 'Project Tracking', icon: 'FolderKanban' },
  { key: 'crm_spellers', group: 'crm', label: 'Spellers', icon: 'Layers' },
  { key: 'quotes_create', group: 'quotes', label: 'Create Quote', icon: 'Plus', permission_key: 'can_access_quotes' },
  { key: 'quotes_recent', group: 'quotes', label: 'Recent Quotes', icon: 'Clock', permission_key: 'can_access_quotes' },
  { key: 'quotes_upload', group: 'quotes', label: 'Upload Quote PDF', icon: 'Upload', permission_key: 'can_access_quotes' },
  { key: 'proforma_create', group: 'proforma', label: 'Create Pro Forma', icon: 'Plus', permission_key: 'can_access_proforma' },
  { key: 'proforma_recent', group: 'proforma', label: 'Recent Pro Formas', icon: 'Clock', permission_key: 'can_access_proforma' },
  { key: 'proforma_upload', group: 'proforma', label: 'Upload Pro Forma PDF', icon: 'Upload', permission_key: 'can_access_proforma' },
  { key: 'stock_transfers', group: 'stock', label: 'Stock Transfers', icon: 'Package', permission_key: 'can_access_stock_transfer' },
  { key: 'stock_b29', group: 'stock', label: 'B29 Transfer', icon: 'Boxes', permission_key: 'can_access_stock_transfer' },
  { key: 'stock_request', group: 'stock', label: 'Stock Request', icon: 'ShoppingCart' },
  { key: 'stockctl_ordering', group: 'stockctl', label: 'Stock Ordering', icon: 'Package', requires: 'can_access_stock_management' },
  { key: 'stockctl_efficiency', group: 'stockctl', label: 'Stock Efficiency', icon: 'TrendingUp', requires: 'can_access_stock_management' },
  { key: 'stockctl_stocktake', group: 'stockctl', label: 'Stocktake', icon: 'ClipboardList', requires: 'can_access_stock_management' },
  { key: 'admin_bi_reports', group: 'admin', label: 'BI Reports', icon: 'LineChart', requires: 'can_access_bi_reports' },
  { key: 'admin_price_increases', group: 'admin', label: 'Price Increases', icon: 'TrendingUp', permission_key: 'can_access_po_expenses' },
  { key: 'admin_cancelled_notif', group: 'admin', label: 'Cancelled Notif', icon: 'CircleAlert', requires: 'can_view_cancelled_notif' },
  { key: 'admin_new_accounts', group: 'admin', label: 'New Accounts', icon: 'UserPlus' },
  { key: 'admin_ho_calculator', group: 'admin', label: 'H/O Support Calculator', icon: 'Calculator' },
  { key: 'admin_my_team', group: 'admin', label: 'My Team', icon: 'Users2', teamManager: true },
];

// Whether a person may see a single link (the Sales / CRM ones have their own check, made by the CRM component). A super admin sees them all.
export const actionVisible = (def, user) => {
  if (!def) return false;
  if (user?.role === 'super_admin') return true;
  if (def.permission_key && user?.[def.permission_key] === false) return false;
  if (def.requires && !user?.[def.requires]) return false;
  if (def.teamManager && !(user?.is_team_manager || user?.can_access_tools)) return false;
  return true;
};

